import { Route, NavigationGuardNext } from "vue-router";
import { getModule } from "vuex-module-decorators";
import LessonPlanTemplateState from "@/modules/lesson-plan-template";

export const LessonPlanTemplateResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	const lessonPlanTemplateModule = getModule(LessonPlanTemplateState);
	const actions: Promise<void>[] = [];
	actions.push(lessonPlanTemplateModule.fetchLessonPlanTemplates());
	await Promise.all(actions);
	next();
};
